require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./journal-record-sale-toorak-garden-features-in-the-age.json") })
        }
      }, "path---journal-record-sale-toorak-garden-features-in-the-age");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---journal-record-sale-toorak-garden-features-in-the-age!./.cache/json/journal-record-sale-toorak-garden-features-in-the-age.json
// module id = 528
// module chunks = 231608221292675